import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/cn';

type ButtonVariant = NonNullable<Parameters<typeof buttonVariants>[0]>['variant'];

// Phase 8.5-05 — generic confirm dialog. Replaces the destructive-only
// `<ConfirmDeleteDialog>` (which now wraps this with destructive defaults).
// Used for low-blast-radius actions like recipient resolve/retry where a
// plain «Confirm?» modal beats a typed-confirmation gate (UX-01 reserved
// for resource-level irreversible ops).
export interface ConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  onConfirm: () => void;
  isPending?: boolean;
  confirmLabel?: string;
  pendingLabel?: string;
  cancelLabel?: string;
  confirmVariant?: ButtonVariant;
}

export const ConfirmDialog = ({
  open,
  onOpenChange,
  title,
  description,
  onConfirm,
  isPending = false,
  confirmLabel = 'Подтвердить',
  pendingLabel = 'Выполняется…',
  cancelLabel = 'Отмена',
  confirmVariant = 'default',
}: ConfirmDialogProps) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>{title}</AlertDialogTitle>
        <AlertDialogDescription>{description}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel disabled={isPending}>{cancelLabel}</AlertDialogCancel>
        <AlertDialogAction
          disabled={isPending}
          onClick={(event) => {
            event.preventDefault();
            onConfirm();
          }}
          className={cn(buttonVariants({ variant: confirmVariant }))}
        >
          {isPending ? pendingLabel : confirmLabel}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
